// extracted by mini-css-extract-plugin
module.exports = {"roleChip":"styles_roleChip__af2Ho","zodiac":"styles_zodiac__yJkKE"};